angular.module('picmonicng').controller('LearnController', [
  '$scope',
  '$state',
  '$q',
  '$window',
  'LearnService',
  'hotkeys',
  'Notes',
  'UserService',
  '$stateParams',
  '$filter',
  'Tracks',
  'MarketOptionsConfig',
  '$timeout',
  'User',
  'PermissionsService',
  'MetaService',
  'WorkflowService',
  'BrowseService',
  'PicmonicQueue',
  '$modal',
  'PlaylistService',
  'QuizService',
  'TokenService',
  'Picmonics',
  '$rootScope',
  'Navigation',
  'PrintAndGoService',
  '$location',
  'SplitTestService',
  '$cookies',
  'ngBowser',
  'toaster',
  function (
    $scope,
    $state,
    $q,
    $window,
    LearnService,
    hotkeys,
    Notes,
    UserService,
    $stateParams,
    $filter,
    Tracks,
    MarketOptionsConfig,
    $timeout,
    User,
    PermissionsService,
    MetaService,
    WorkflowService,
    BrowseService,
    PicmonicQueue,
    $modal,
    PlaylistService,
    QuizService,
    TokenService,
    Picmonics,
    $rootScope,
    Navigation,
    PrintAndGoService,
    $location,
    SplitTestService,
    $cookies,
    ngBowser,
    toaster
  ) {
    /*
        if (!UserService.user.user_id) {
            var redirect = location.pathname;
            window.onbeforeunload = null;
            window.location = "/register?status=401&redirect=" + encodeURIComponent(redirect);
        }
        */

    if (
      UserService.user.user_id &&
      UserService.user.is_trial &&
      [100, 105, 203].indexOf(UserService.user.lead) !== false
    ) {
      $scope.showAddFact = true;
    }

    $scope.embedRegister = function () {
      window.top.angular.element(window.top.document.body).injector().get('UserService').showRegisterModal();
    };

    if ($scope.embed) {
      $scope.$on('audioLoaded', function () {
        if (!LearnService.quiz && UserService.user.tos_accepted && !UserService.user.settings.set_email) {
          LearnService.playAudio();
        }
      });
      if (!UserService.user.tos_accepted) {
        UserService.showTOSModal().result.then(function () {
          LearnService.playAudio();
          atlasEvent('completed', 'lti_tos_modal');
        });
      }
    }

    var start = Date.now();
    $scope.LearnService = LearnService;
    $scope.QuizService = QuizService;
    $scope.TokenService = TokenService;
    $scope.WorkflowService = WorkflowService;
    $scope.PermissionsService = PermissionsService;
    $scope.PicmonicQueue = PicmonicQueue;
    $scope.school = UserService.user.school;
    $scope.MarketOptionsConfig = MarketOptionsConfig;
    $scope.newFact = {};
    $scope.windowHasFocus = true;
    $scope.scrollIsAtTop = true;
    $scope.UserService = UserService;
    $scope.Math = window.Math;
    $scope.trialPicmonics = MarketOptionsConfig.getMarketById(UserService.user.lead).free_trial_picmonics || [];

    $scope.isOnMobile = ngBowser.isMobile();
    $scope.isIos = ngBowser.isIOS();
    $scope.isAndroid = ngBowser.isAndroid();

    angular.element(window).blur(function () {
      if (!$scope.$$phase) {
        $scope.$apply(function () {
          $scope.windowHasFocus = false;
        });
      }
    });

    angular.element(window).focus(function () {
      if (!$scope.$$phase) {
        $scope.$apply(function () {
          $scope.windowHasFocus = true;
        });
      }
    });

    // Tab into player settings
    angular.element(document).on('blur', '.player-settings-toggle', function (e) {
      e.stopImmediatePropagation();
      e.preventDefault();
      if (e.relatedTarget != null && e.relatedTarget == angular.element('div.left-sidebar-wrapper')[0]) {
        angular
          .element('.player-settings-tooltip-wrapper ul li ui-toggle, .player-settings-wrapper ul li ui-slider')
          .first()
          .focus();
      }
    });

    // Tab out of player settings
    angular.element(document).on('blur', '.player-settings-tooltip-wrapper ul li .settings-control:last', function (e) {
      e.stopImmediatePropagation();
      e.preventDefault();
      if (e.relatedTarget == null) {
        // Don't trigger when tabbing backwards
        angular.element('.player-settings-toggle').click();
      }
    });

    $scope.updateSettings = function () {
      if (UserService.user.user_id) {
        if ($scope.updateSettingsPromise) {
          $timeout.cancel($scope.updateSettingsPromise);
        }

        $scope.updateSettingsPromise = $timeout(function () {
          UserService.user.$update().finally(function () {
            if (LearnService.mode == 'review' && !UserService.user.enable_master) {
              LearnService.startLearn();
            }
          });
        }, 3000);
      }
    };

    if ($state.current.name === 'app.quiz' && $stateParams.quiz_type != 'picmonic') {
      if (UserService.user.is_trial) {
        TokenService.values.$promise.then(function (values) {
          if (
            ($stateParams.quiz_type != 'spacedrep' && !values.quiz_questions) ||
            ($stateParams.quiz_type == 'spacedrep' && !values.spacedrep_rounds)
          ) {
            PicmonicQueue.goToQuiz($stateParams.resource_id, $stateParams.quiz_type);
            return;
          } else {
            QuizService.init($stateParams.quiz_type, $stateParams.resource_id, {}, $stateParams);
          }
        });
      } else {
        QuizService.init($stateParams.quiz_type, $stateParams.resource_id, {}, $stateParams);
      }

      LearnService.quiz = true;
      LearnService.player_mode = 'quiz';
      LearnService.theater = 1;
      LearnService.factsOpen = 0;
      LearnService.mode = 'learn';
      LearnService.learnComplete = false;
      LearnService.endTime = 0;
      LearnService.insideQuiz = true;
      LearnService.assetStatus = [];
      LearnService.assetsLoaded = true;
      $scope.quizOnly = 1;
      var hotkey_bindings = hotkeys.bindTo($scope);
      QuizService.addHotKeys(hotkey_bindings);
      function hotkeysenabled(in_modal, in_browse, in_summary, on_learn) {
        if (!UserService.user.user_id || !LearnService.currentCard.is_owned) {
          return false;
        }

        if (!QuizService.currentQuestion.answerSelected) {
          return false;
        }

        if (QuizService.quizMode == 'fill-in-the-blank') {
          return false;
        }

        if (!QuizService.currentQuestion.answered_zoom || !QuizService.currentQuestion.picmonic.is_owned) {
          QuizService.showQuizLearnPlayer();
        }
        return true;
      }
      // Bind the hotkeys for the defined shortcuts
      for (var shortcut in LearnService.keyboard_shortcuts) {
        if (LearnService.keyboard_shortcuts.hasOwnProperty(shortcut)) {
          LearnService.keyboard_shortcuts[shortcut].keys.forEach(function (key) {
            hotkey_bindings.add({
              combo: key,
              description: LearnService.keyboard_shortcuts[shortcut].prelearn_description,
              callback: (function (k, s) {
                return function (e) {
                  return hotkeysenabled(
                    LearnService.keyboard_shortcuts[s].modal ? true : false,
                    LearnService.keyboard_shortcuts[s].browse ? true : false,
                    LearnService.keyboard_shortcuts[s].summary ? true : false,
                    LearnService.keyboard_shortcuts[s].learn ? true : false
                  )
                    ? LearnService.keyboard_shortcuts[s].callback(k, e)
                    : false;
                };
              })(key, shortcut),
            });
          });
        }
      }
      return;
    }

    LearnService.reset();
    PicmonicQueue.setCurrent($stateParams.slug);
    LearnService.showPreLearnModal();

    $scope.loading = true;

    LearnService.getCard($stateParams.slug || $stateParams.resource_id, true, true)
      .then(
        function (resolvedData) {
          if (
            !$rootScope.embed &&
            !UserService.user.user_id &&
            resolvedData.currentCard.entity_type_id === 2 &&
            resolvedData.currentCard.primary_tracks.length
          ) {
            window.onbeforeunload = null;
            var lead = $cookies.get('pls_user_lead');
            primaryTrack = $filter('filter')(resolvedData.currentCard.primary_tracks, { market_id: lead });
            if (lead && primaryTrack.length) {
              primaryTrack = primaryTrack[0];
            } else {
              primaryTrack = $filter('filter')(resolvedData.currentCard.primary_tracks, {
                market_id: resolvedData.currentCard.primary_market_id,
              })[0];
            }

            if (primaryTrack.market_id) {
              window.location =
                '/pathways/' +
                primaryTrack.market_slug +
                '/' +
                primaryTrack.root_pathway_type +
                '/' +
                (primaryTrack.root_pathway_curriculum ? primaryTrack.root_pathway_curriculum + '/' : '') +
                $filter('slugify')(primaryTrack.root_pathway_name) +
                '-' +
                primaryTrack.root_pathway_id +
                '/' +
                $filter('slugify')(primaryTrack.track_name) +
                '-' +
                primaryTrack.track_id +
                '/' +
                resolvedData.currentCard.slug +
                ($location.search().ref ? '?ref=' + $location.search().ref : '') +
                ($location.search().afl ? '?afl=' + $location.search().afl : '') +
                ($location.search().amb ? '?amb=' + $location.search().amb : '') +
                ($location.search().register
                  ? ($location.search().ref || $location.search().afl || $location.search().amb ? '&' : '?') +
                    'register=' +
                    $location.search().register
                  : '');
              return;
            }
          }

          $rootScope.$broadcast('cardDataChanged', {
            action: 'learn_get',
            card_id: LearnService.currentCard.card_id,
          });

          MetaService.replace('%LEARN%', resolvedData.currentCard.name);
          MetaService.replace(
            '%IMAGE%',
            'https://cdn.picmonic.com/cloud_data/images_panel_thumb/' + resolvedData.currentCard.main_image
          );

          LearnService.init(resolvedData);

          LearnService.startCard();
          LearnService.assetStatus = [];
          LearnService.assetsLoaded = true;
          $scope.$emit('endInteraction');
          $scope.loading = false;
          console.log('Finished: ' + (Date.now() - start));
          LearnService.initQuiz();

          if (LearnService.preLearnVisible) {
            $rootScope.bodyClass.push('prelearn-overlay-mobile-lock');
            if (UserService.user.user_id) {
              $timeout(function () {
                angular.element('#prelearn-play-button').focus().select();
              });
            } else {
              $timeout(function () {
                angular.element('#play-button-border').focus().select();
              });
            }
          }

          var track_id;
          if (PicmonicQueue.track_id) {
            track_id = PicmonicQueue.track_id;
          } else if (
            UserService.user.current_track_id &&
            LearnService.currentCard.tracks &&
            $filter('filter')(LearnService.currentCard.tracks, { track_id: UserService.user.current_track_id }, true)
              .length
          ) {
            track_id = UserService.user.current_track_id;
          } else if (
            UserService.user.lead &&
            $filter('arrayPos')(LearnService.currentCard.primary_tracks, UserService.user.lead, 'market_id') != null
          ) {
            track_id =
              LearnService.currentCard.primary_tracks[
                $filter('arrayPos')(LearnService.currentCard.primary_tracks, UserService.user.lead, 'market_id')
              ].track_id;
          } else if (
            LearnService.currentCard.primary_market_id &&
            $filter('arrayPos')(
              LearnService.currentCard.primary_tracks,
              LearnService.currentCard.primary_market_id,
              'market_id'
            ) != null
          ) {
            track_id =
              LearnService.currentCard.primary_tracks[
                $filter('arrayPos')(
                  LearnService.currentCard.primary_tracks,
                  LearnService.currentCard.primary_market_id,
                  'market_id'
                )
              ].track_id;
          }

          if (track_id) {
            $scope.track = Tracks.get({ track_id: track_id });
          }

          if (UserService.user.user_id) {
            LearnService.loadCommunityFacts();
            $scope.recommended = User.recommended({
              type: 'learn',
              track_id: track_id,
              card_id: LearnService.currentCard.card_id,
            });
            $scope.breadcrumbs = User.queryv3({
              resource: 'picmonic',
              resource_id: LearnService.currentCard.card_id,
              resource2: 'breadcrumbs',
            });
          }

          if ($state.current.name === 'app.quiz') {
            LearnService.dismissPrelearnModal(true).then(function () {
              LearnService.startQuiz();
            });
          }

          $scope.froalaOptions = {
            key: 'LB-22encg1C-8xqA2wzA-13==',
            autosave: true,
            autosaveInterval: 10000,
            saveRequestType: 'PUT',
            saveParam: 'note',
            inlineMode: false,
            defaultImageTitle: '',
            saveURL: '/api/v2/picmonics/' + LearnService.currentCard.card_id,
            imageUploadURL: '/api/v2/picmonics/' + LearnService.currentCard.card_id + '/upload',
            theme: 'custom',
            events: {
              saveError: function (e, editor, error) {
                alert('Could not save note!');
              },
              beforeSave: function (e, editor) {
                $scope.noteSaving = true;
              },
              afterSave: function (e, editor, data) {
                $scope.$apply(function () {
                  if (typeof data === 'string') {
                    data = JSON.parse(data);
                  }

                  LearnService.currentCard.user_notes.updated_at = data.user_notes.updated_at;
                  $scope.noteSaving = false;
                });
              },
            },
            height: '94%',
            buttons: [
              'bold',
              'italic',
              'underline',
              'strikeThrough',
              'align',
              'insertOrderedList',
              'insertUnorderedList',
              'fontFamily',
              'fontSize',
              'color',
              'subscript',
              'superscript',
              'insertImage',
              'save',
            ],
          };
        },
        function (error) {
          if (typeof atlasEvent !== 'undefined') {
            atlasEvent('404', document.location);
          }

          var query = $stateParams.slug;
          if ($stateParams.slug && $stateParams.slug.indexOf('_')) {
            query = $stateParams.slug.split('_')[0].replace(/\-/g, ' ');
          }

          $scope.loading = false;
          $scope.$emit('endInteraction');
          $state.transitionTo('app.learn404', {
            error: error.data.error,
            suggested: error.data.suggested,
            query: query,
          });
        }
      )
      .finally(function () {
        LearnService.locked = UserService.user.is_trial && LearnService.currentCard.entity_type_id == 2 && !LearnService.currentCard.is_owned && !LearnService.currentCard.is_free && (!$scope.trialPicmonics.includes(String(LearnService.currentCard.card_id)) || UserService.user.free_trial_expiration < Date.now() / 1000);
        $scope.loading = false;
      });

    angular.element('body').scrollTop(0);

    if (UserService.user.user_id) {
      $window.onbeforeunload = function (event) {
        if ($state.current.name == 'app.learn') {
          LearnService.saveCardAttempt(0);
          LearnService.saveVisibleSegments();
        }
      };
    }

    function hotkeysenabled(in_modal, in_browse, in_summary, on_learn) {
      if (!UserService.user.user_id || !LearnService.currentCard.is_owned) {
        return false;
      }

      if (LearnService.quiz) {
        if (!QuizService.currentQuestion.answerSelected) {
          return false;
        }

        if (QuizService.quizMode == 'fill-in-the-blank') {
          return false;
        }

        if (!QuizService.currentQuestion.answered_zoom || !QuizService.currentQuestion.picmonic.is_owned) {
          QuizService.showQuizLearnPlayer();
        }
      }

      if (LearnService.showPostBar) {
        return false;
      }

      if (LearnService.preLearnVisible) {
        LearnService.dismissPrelearnModal();
      }
      if (LearnService.modalInstance) {
        LearnService.modalInstance.close();
      }
      return (
        (in_browse || !BrowseService.browseOpen) &&
        (in_summary || !LearnService.summaryOpen) &&
        ($state.current.name == 'app.learn' || $state.current.name == 'app.quiz')
      );
    }

    // Bind the hotkeys for the defined shortcuts
    var hotkey_bindings = hotkeys.bindTo($scope);
    for (var shortcut in LearnService.keyboard_shortcuts) {
      if (LearnService.keyboard_shortcuts.hasOwnProperty(shortcut)) {
        LearnService.keyboard_shortcuts[shortcut].keys.forEach(function (key) {
          hotkey_bindings.add({
            combo: key,
            description: LearnService.keyboard_shortcuts[shortcut].prelearn_description,
            callback: (function (k, s) {
              return function (e) {
                return hotkeysenabled(
                  LearnService.keyboard_shortcuts[s].modal ? true : false,
                  LearnService.keyboard_shortcuts[s].browse ? true : false,
                  LearnService.keyboard_shortcuts[s].summary ? true : false,
                  LearnService.keyboard_shortcuts[s].learn ? true : false
                )
                  ? LearnService.keyboard_shortcuts[s].callback(k, e)
                  : false;
              };
            })(key, shortcut),
          });
        });
      }
    }

    $scope.noteSaving = false;

    $scope.saveNote = function () {
      $scope.froalaOptions.froala('save');
    };

    $scope.shareNote = function () {
      var notes = [];
      notes.push(LearnService.currentCard.card_id);

      StudyNotes.shareUserNotes(notes).success(function (results) {
        LearnService.currentCard.user_notes.is_public = !LearnService.currentCard.user_notes.is_public;
      });
    };

    var factSelectedFromHover = false;

    $scope.initOverlayPreview = function () {
      if (!$scope.isOnMobile) {
        angular
          .element('.setting-overlay-mask')
          .on('mouseenter', function () {
            if (!LearnService.currentFact.fact_id) {
              factSelectedFromHover = true;
              LearnService.selectFact(LearnService.currentFacts[0]);
              $scope.$apply();
            }
          })
          .on('mouseleave', function () {
            if (factSelectedFromHover) {
              LearnService.clearSelectedFact();
              factSelectedFromHover = false;
              $scope.$apply();
            }
          });
      }
    };

    $scope.initBlurPreview = function () {
      if (!$scope.isOnMobile) {
        angular
          .element('.setting-quiz-blur')
          .on('mouseenter', function () {
            LearnService.showBlur = true;
            $scope.$apply();
          })
          .on('mouseleave', function () {
            LearnService.showBlur = false;
            $scope.$apply();
          });
      }
    };

    $scope.factAutoSuggestResults = { results: [] };
    $scope.createFact = function (item) {
      // If the user entered a fact but didn't click a result from the auto suggest and it exactly matches a result from the auto suggest then select it for the user
      // This section logic is duplicated in editor.js createFact
      if (!item && $scope.newFact.name && $scope.factAutoSuggestResults.results.length) {
        angular.forEach($scope.factAutoSuggestResults.results, function (result) {
          if (result.name.toLowerCase() === $scope.newFact.name.toLowerCase()) {
            item = result;
          }
        });
      }

      if (item || $scope.newFact.name) {
        $scope.loading = true;
        $state.go('app.editor', {
          slug: LearnService.currentCard.slug,
          tab: 'fact',
          newFact: item ? item : $scope.newFact.name,
          returnTo: 'app.learn',
          returnAfterFact: true,
        });
      }
    };

    $scope.showOsmosisModal = function () {
      send_ga('event', 'Learn', 'Osmosis Info Clicked');

      $modal.open({
        templateUrl: '/templates/modals/osmosis.html',
        windowClass: 'below-nav learn-light-modal',
        backdropClass: 'below-nav',
        size: 'md',
        controller: [
          '$scope',
          '$modalInstance',
          '$timeout',
          function ($scope, $modalInstance, $timeout) {
            $scope.learnMore = function () {
              send_ga('event', 'Learn', 'Osmosis Learn More Clicked');
            };

            $scope.close = function () {
              $modalInstance.close();
            };
          },
        ],
      });
    };

    // Scroll the sidebar on appearance of autosuggest
    $scope.autoSuggestDropdown = function () {
      var autosuggest = angular.element('#learn-fact-autosuggest');
      $timeout(function () {
        var scroller = angular.element('.player-sidebar-wrapper--scrollable');
        var top = scroller.scrollTop() - scroller.offset().top + autosuggest.offset().top - 16;
        scroller.animate({ scrollTop: top }, 500);
      }, 0);
    };

    $scope.setConfidenceRating = function (rating) {
      if (LearnService.currentCard.rating != rating) {
        LearnService.currentCard.rating = rating;
        LearnService.currentCard.$update();
      }
    };

    $scope.addToPlaylist = function (playlist) {
      PlaylistService.addCard(LearnService.currentCard.card_id, playlist);
    };

    $scope.addToNewPlaylist = function () {
      var card_id = LearnService.currentCard.card_id;
      PlaylistService.create().then(function (playlist) {
        PlaylistService.addCard(card_id, playlist);
      });
    };

    $scope.$on('$destroy', function () {
      if (LearnService.shortcutsModal) {
        LearnService.shortcutsModal.close();
      }

      LearnService.quiz = false;
      LearnService.theater = UserService.user.user_id
        ? typeof UserService.user.settings.learn_theater != 'undefined'
          ? UserService.user.settings.learn_theater
          : 0
        : 0;

      if ($rootScope.bodyClass.indexOf('playing') !== -1) {
        $rootScope.bodyClass.splice($rootScope.bodyClass.indexOf('playing'), 1);
      }

      if (LearnService.relatedModalInstance) {
        LearnService.relatedModalInstance.close();
      }

      if ($rootScope.bodyClass.indexOf('prelearn-overlay-mobile-lock') !== -1) {
        $rootScope.bodyClass.splice($rootScope.bodyClass.indexOf('prelearn-overlay-mobile-lock'), 1);
      }
    });

    $scope.$watch(
      function () {
        return LearnService.audioElement ? LearnService.audioElement.paused : true;
      },
      function (value) {
        if (!angular.isArray($rootScope.bodyClass)) {
          $rootScope.bodyClass = [];
        }
        if (value && $rootScope.bodyClass.indexOf('playing') !== -1) {
          $rootScope.bodyClass.splice($rootScope.bodyClass.indexOf('playing'), 1);
        } else if (!value) {
          $rootScope.bodyClass.push('playing');
        }
      }
    );

    $scope.togglePlaylistSubMenu = function () {
      if (typeof PlaylistService.playlists.$promise == 'undefined') {
        PlaylistService.init();
      }
      $scope.addToPlaylistSubMenu = !$scope.addToPlaylistSubMenu;
    };

    $scope.pathwayName = function () {
      if (!$scope.track.root_pathway_curriculum || $scope.track.root_pathway_curriculum == 'standard') {
        return $scope.track.root_pathway_pathway_type.ucwords();
      } else {
        return $scope.track.root_pathway_curriculum
          .ucwords()
          .replace('Nclex', 'NCLEX®')
          .replace('Usmle', 'USMLE')
          .split('-')
          .join(' ');
      }
    };

    $scope.breadcrumbName = function (breadcrumb) {
      if (!breadcrumb.root_curriculum || breadcrumb.root_curriculum == 'standard') {
        return breadcrumb.root_pathway_type.ucwords();
      } else {
        return breadcrumb.root_curriculum
          .ucwords()
          .replace('Nclex', 'NCLEX®')
          .replace('Usmle', 'USMLE')
          .split('-')
          .join(' ');
      }
    };

    $scope.print = function () {
      PrintAndGoService.print('card', LearnService.currentCard.card_id);
    };

    //Learn Player is scrollable or locked
    $scope.learnIsScrollable = function () {
      //character not selected OR learn info is scrolled to top
      //will enable scrollable for mobile
      if (window.innerWidth < 480) {
        if (LearnService.currentFact.characters || !$scope.scrollIsAtTop) {
          return false;
        }
        return true;
      }

      return (
        (UserService.user.user_id &&
          !LearnService.preLearnVisible &&
          LearnService.audioElement &&
          LearnService.audioElement.paused) ||
        (!UserService.user.user_id && LearnService.audioElement && LearnService.audioElement.paused)
      );
    };

    $scope.clickMoreMenuPlayer = function () {
      UserService.see('player_more_menu');
    };

    $scope.approvePremiumUgc = function () {
      Picmonics.approvePremiumUgc({
        card_id: LearnService.currentCard.card_id,
      }).$promise.then(function (card) {
        window.location = '/learn/' + card.slug;
      });
    };

    $scope.submitVUGC = function () {
      Picmonics.submitVUGC({
        card_id: LearnService.currentCard.card_id,
      }).$promise.then(function (card) {
        toaster.success('Submitted for Approval!');
      });
    };

    $scope.goToEditor = function (slug) {
      window.location = '/editor/' + slug;
    };

    var resume = false;
    $scope.$watch(
      function () {
        return BrowseService.browseOpen;
      },
      function () {
        if (BrowseService.browseOpen && LearnService.audioElement && !LearnService.audioElement.paused) {
          resume = true;
          LearnService.audioElement.pause();
          return;
        }
        if (!BrowseService.browseOpen && resume) {
          LearnService.audioElement.play();
        }

        resume = false;
      }
    );
    $scope.recommendedIndex = 0;
    $scope.prevRec = function () {
      $scope.recommendedIndex = Math.max(0, $scope.recommendedIndex - 1);
    };
    $scope.nextRec = function () {
      $scope.recommendedIndex = Math.min($scope.recommended.cards.length - 4, $scope.recommendedIndex + 1);
    };
  },
]);
